import React, { useContext, useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { Link } from 'react-router-dom'
import ContentHeader from '../../../../Components/Layout/ContentHeader'
import LayoutTable from '../../../../Components/Global/LayoutTable'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { AuthContext } from '../../../../Auth/AuthContext'
import { objNameRoles } from '../../../../const/constRoles'
import {
  GET_USERS,
  DELETE_USER,
  EXPORT_USERS,
  UPDATE_STATUS_DISABLED_USER,
} from '../../../../graphql/Catalog/Users/user'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import moment from 'moment'
const List = () => {
  const { showLoading, hideLoading } = useLoading()
  const { user } = useContext(AuthContext)

  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })
  const [total, setTotal] = useState(0)
  const { loading, error, data, refetch } = useQuery(GET_USERS, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
    },
  })
  const [dataToTable, setDataToTable] = useState([])

  //MUTATION
  const [updateDisableStatus] = useMutation(UPDATE_STATUS_DISABLED_USER)

  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data.Users.rows.map((item) => {
        const respData = {
          id: item.id,
          nombre: item.name,
          usuario: item.username,
          correo: item.email,
          rol: item?.RoleOfUser?.role_name,
        }

        if ([objNameRoles.master, objNameRoles.admin].includes(user.role)) {
          respData.ordenar = (
            <Link
              className="btn btn-migrates btn-sm mb-1"
              to={`/orderPermissions/user/${item.id}`}
            >
              <i className="fas fa-retweet" />
            </Link>
          )

          respData.estatus = (
            <button
              className={`btn btn-sm ${
                item.is_disabled ? 'btn-danger' : 'btn-success'
              } mb-1`}
              title={!item.is_disabled ? 'Habilitado' : 'Deshabilitado'}
              onClick={() =>
                handleStatusDisable(item.id, item.is_disabled, item.disabled_at)
              }
            >
              <i
                className={`fas ${item.is_disabled ? 'fa-times' : 'fa-check'}`}
              ></i>
            </button>
          )
        }

        return list.push(respData)
      })
      setDataToTable(list)
      setTotal(data.Users.count)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  const handleStatusDisable = async (id, is_disabled, dateDisable) => {
    try {
      const response = await toastSweetAlert({
        mode: 'modalConfirmCancel',
        message: is_disabled
          ? `¿Estás seguro de que deseas habilitar este usuario?.
            Desactivado el ${moment(dateDisable).format('DD/MM/YYYY HH:mm:ss')}`
          : '¿Estás seguro de que deseas deshabilitar este usuario?',
        icon: 'warning',
        confirmButtonText: is_disabled ? 'Habilitar' : 'Deshabilitar',
      })

      if (!response.isConfirmed) return
      showLoading()
      const { data: responseData } = await updateDisableStatus({
        variables: {
          userId: +id,
          disableValue: !is_disabled,
        },
        // fetchPolicy: 'cache-and-network',
      })

      if (responseData.updateUserDisabledStatus) {
        await refetch()
        return toastSweetAlert({
          mode: 'ok',
          message: is_disabled
            ? 'Usuario habilitado correctamente.'
            : 'Usuario deshabilitado correctamente.',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader
        title="Control de usuarios"
        breadcrumb="Usuarios"
        windowTitle="Usuarios"
      />
      <LayoutTable
        data={dataToTable}
        title="Lista de usuarios"
        gql={DELETE_USER}
        requery={GET_USERS}
        exportQuery={EXPORT_USERS}
        totalCount={total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loading}
        FilterBarPlaceholder="Buscar por nombre o correo"
        hideDetails
      />
    </>
  )
}
export default List
